var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmbeddedVideo',{staticClass:"video",attrs:{"video":_vm.video}})
}
var staticRenderFns = []

export { render, staticRenderFns }